import {Cureus} from '../Cureus';

Cureus.AdminDeferralReasons = {};

//= require_tree ./AdminDeferralReasons
